function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconParkingInACircleDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0666 8.91436C11.6456 9.29819 11.0558 9.48979 10.2976 9.48979H7.77447C7.51368 9.48979 7.30225 9.2772 7.30225 9.01461V5.25373C7.30225 4.99149 7.51368 4.77881 7.77447 4.77881H10.2976C11.0558 4.77881 11.6456 4.95604 12.0666 5.3106C12.4875 5.66551 12.6978 6.25876 12.6978 7.09087C12.6978 7.92317 12.4875 8.53097 12.0666 8.91436ZM14.5959 3.23729C13.6598 2.41231 12.4044 2 10.83 2H4.47222C4.21152 2 4 2.21268 4 2.47492V17.5251C4 17.7873 4.21152 18 4.47222 18H6.82983C7.09079 18 7.30223 17.7873 7.30223 17.5251V12.7218C7.30223 12.4595 7.51366 12.2468 7.77445 12.2468H10.6144C12.3424 12.2468 13.6721 11.8562 14.6031 11.0746C15.5344 10.293 16 8.95771 16 7.06907C16 5.33976 15.532 4.06226 14.5959 3.23729Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkingInACircleDark);
export default __webpack_public_path__ + "static/media/icon-parking-in-a-circle-dark.27e364b5dc2ba309c8139072d7404034.svg";
export { ForwardRef as ReactComponent };